import styled from "styled-components";

export const CenterContainer = styled.div`
  display: flex;
  justify-content: center;
`;

export const RegisterContainer = styled.div`
  box-shadow: 0px 10px 15px -3px rgba(0, 0, 0, 0.1);
  padding: 1rem;
  min-width: 20rem;
`;

export const RegisterContainerHeader = styled.h1`
  font-weight: bold;
  text-align: center;
`;

export const InputField = styled.input`
  padding: 1rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  resize: vertical;
`;

export const LabelInput = styled.label`
  font-weight: semibold;
  margin-bottom: 0.5rem;
`;

export const FieldElement = styled.div`
  display: flex;
  flex-direction: column;
  margin: 1rem;
`;

export const RegisterButton = styled.button`
  width: 100%;
  padding: 1rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  background-color: #fff;
  color: #000;
  font-weight: bold;
  cursor: pointer;
  &:hover {
    background-color: #ccc;
    color: #fff;
  }
`;
